import { render, staticRenderFns } from "./ShopVoteBadge.vue?vue&type=template&id=c97eef76"
import script from "./ShopVoteBadge.vue?vue&type=script&lang=js"
export * from "./ShopVoteBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports